"use client";

import {
  Button,
  Column,
  Cover,
  Flex,
  Heading,
  Row,
  variables,
} from "politicamente-informados-ds";
import React, { Suspense } from "react";

import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import Image from "next/image";
import Link from "next/link";
import NavigationEvents from "@/components/common/NavigationEvents/NavigationEvents";

export default function NotFound() {

  return (
    <>
      <Suspense>
        <NavigationEvents acf={{ page_style: "dark", header_absolute: false }} />
      </Suspense>
      <Cover
        minHeight={"100dvh"}
        // imageElement={
        //   <DisplayImage
        //     alt={"Page 404"}
        //     url={"/assets/components/404.png"}
        //     fill={true}
        //     priority={true}
        //   />
        // }
        overlayOpacity={1}
        overlayColor={variables.colors.gray100}
      >
        <Row className="pt-6 pb-6">
          <Column md={12}>
            <Flex justify="center" align="center" direction="column">
              <div>
                <Heading tag="h1" size="display" className="text-uppercase fw-bold" style={{ color: '#FADA3C' }}>
                  404
                </Heading>
                <Heading tag="h2" size="h1" className="mb-4 fw-bold" style={{ marginLeft: '80px' }}>
                  Página não encontrada.
                </Heading>
                <Heading tag="h3" size="h3" className="mb-6">
                  Pedimos desculpa pelo incómodo. Por favor, volte à página inicial.
                </Heading>

                <Flex justify='center'>
                  <Link href="/" prefetch={false}>
                    <Button
                      variant="primary"
                    >
                      Voltar para a página inicial
                    </Button>
                  </Link>
                </Flex>
              </div>
            </Flex>
          </Column>
        </Row>

      </Cover>
    </>
  );
}
